import AgendaItem from "@/domain/entities/agenda/AgendaItem";
import { setSettingsDialogOpen } from "@/stores/settingsStore";
import { Store } from "@tanstack/react-store";

const eventStore = new Store({
    openedEvent: undefined as AgendaItem | undefined,
    focusedEvent: undefined as AgendaItem | undefined,
});

export const setOpenedEvent = (event: AgendaItem | undefined) => {
    if (event) {
        // EventModal portals to <body> in edit mode; closing the Settings
        // dialog first avoids being caught by its Radix scroll lock.
        setSettingsDialogOpen(false);
    }

    eventStore.setState((state) => ({
        ...state,
        openedEvent: event,
    }));
};

export const focusEventInCalendar = (event: AgendaItem | undefined) => {
    eventStore.setState((state) => ({
        ...state,
        focusedEvent: event,
    }));
};

export default eventStore;
